/**
 * AUTO-GENERATED by agent-contracts-runtime. DO NOT EDIT.
 *
 * Regenerate via: npx agent-runtime generate
 */

import { z } from "zod";

// ---------------------------------------------------------------------------
// litedbmodel-audit-request
// ---------------------------------------------------------------------------

export const LitedbmodelAuditRequestSchema = z.object({
  userRequest: z.string(),
});

export type LitedbmodelAuditRequest = z.infer<typeof LitedbmodelAuditRequestSchema>;

// ---------------------------------------------------------------------------
// litedbmodel-implement-request
// ---------------------------------------------------------------------------

export const LitedbmodelImplementRequestSchema = z.object({
  userRequest: z.string(),
});

export type LitedbmodelImplementRequest = z.infer<typeof LitedbmodelImplementRequestSchema>;

// ---------------------------------------------------------------------------
// litedbmodel-audit-result
// ---------------------------------------------------------------------------

export const LitedbmodelAuditResultSchema = z.object({
  summary: z.string(),
  riskLevel: z.enum(["low", "medium", "high", "critical"]),
  findings: z.array(z.object({
  id: z.string().optional(),
  severity: z.enum(["info", "warning", "error", "critical"]),
  category: z.string(),
  target: z.string().optional(),
  location: z.string().optional(),
  message: z.string(),
  recommendation: z.string().optional(),
  confidence: z.number().min(0).max(1).optional(),
  evidence: z.array(z.object({
  type: z.string(),
  content: z.string(),
  source: z.string().optional(),
})).optional(),
  details: z.record(z.string(), z.unknown()).optional(),
})),
  recommendedActions: z.array(z.object({
  kind: z.enum(["run_command", "edit_file", "review", "confirm", "block", "ignore"]),
  title: z.string(),
  command: z.string().optional(),
  target: z.string().optional(),
  rationale: z.string().optional(),
})).optional(),
  metadata: z.object({
  tool: z.string().optional(),
  command: z.string().optional(),
  version: z.string().optional(),
  generatedAt: z.string().optional(),
  adapter: z.string().optional(),
  model: z.string().optional(),
}).optional(),
});

export type LitedbmodelAuditResult = z.infer<typeof LitedbmodelAuditResultSchema>;

// ---------------------------------------------------------------------------
// litedbmodel-implement-result
// ---------------------------------------------------------------------------

export const LitedbmodelImplementResultSchema = z.object({
  summary: z.string(),
  riskLevel: z.enum(["low", "medium", "high", "critical"]),
  findings: z.array(z.object({
  id: z.string().optional(),
  severity: z.enum(["info", "warning", "error", "critical"]),
  category: z.string(),
  target: z.string().optional(),
  location: z.string().optional(),
  message: z.string(),
  recommendation: z.string().optional(),
  confidence: z.number().min(0).max(1).optional(),
  evidence: z.array(z.object({
  type: z.string(),
  content: z.string(),
  source: z.string().optional(),
})).optional(),
  details: z.record(z.string(), z.unknown()).optional(),
})),
  recommendedActions: z.array(z.object({
  kind: z.enum(["run_command", "edit_file", "review", "confirm", "block", "ignore"]),
  title: z.string(),
  command: z.string().optional(),
  target: z.string().optional(),
  rationale: z.string().optional(),
})).optional(),
  changedFiles: z.array(z.object({
  path: z.string(),
  action: z.enum(["created", "updated"]),
  rationale: z.string().optional(),
})),
  dependencies: z.array(z.string()).optional(),
  notes: z.string().optional(),
  metadata: z.object({
  tool: z.string().optional(),
  command: z.string().optional(),
  version: z.string().optional(),
  generatedAt: z.string().optional(),
  adapter: z.string().optional(),
  model: z.string().optional(),
}).optional(),
});

export type LitedbmodelImplementResult = z.infer<typeof LitedbmodelImplementResultSchema>;

// ---------------------------------------------------------------------------
// Schema registry
// ---------------------------------------------------------------------------

export const handoffSchemas = {
  "litedbmodel-audit-request": LitedbmodelAuditRequestSchema,
  "litedbmodel-implement-request": LitedbmodelImplementRequestSchema,
  "litedbmodel-audit-result": LitedbmodelAuditResultSchema,
  "litedbmodel-implement-result": LitedbmodelImplementResultSchema,
} as const;

export type HandoffTypeId = keyof typeof handoffSchemas;

// ---------------------------------------------------------------------------
// Handoff envelope
// ---------------------------------------------------------------------------

export interface HandoffEnvelope<T extends HandoffTypeId = HandoffTypeId> {
  readonly type: T;
  readonly version: number;
  readonly payload: z.infer<(typeof handoffSchemas)[T]>;
}

// ---------------------------------------------------------------------------
// Factory functions — type-safe constructors with runtime validation
// ---------------------------------------------------------------------------

export const handoffs = {
  litedbmodelAuditRequest(payload: LitedbmodelAuditRequest): HandoffEnvelope<"litedbmodel-audit-request"> {
    return {
      type: "litedbmodel-audit-request" as const,
      version: 1,
      payload: LitedbmodelAuditRequestSchema.parse(payload),
    };
  },
  litedbmodelImplementRequest(payload: LitedbmodelImplementRequest): HandoffEnvelope<"litedbmodel-implement-request"> {
    return {
      type: "litedbmodel-implement-request" as const,
      version: 1,
      payload: LitedbmodelImplementRequestSchema.parse(payload),
    };
  },
  litedbmodelAuditResult(payload: LitedbmodelAuditResult): HandoffEnvelope<"litedbmodel-audit-result"> {
    return {
      type: "litedbmodel-audit-result" as const,
      version: 1,
      payload: LitedbmodelAuditResultSchema.parse(payload),
    };
  },
  litedbmodelImplementResult(payload: LitedbmodelImplementResult): HandoffEnvelope<"litedbmodel-implement-result"> {
    return {
      type: "litedbmodel-implement-result" as const,
      version: 1,
      payload: LitedbmodelImplementResultSchema.parse(payload),
    };
  },
} as const;
